import React, { useRef } from "react";
import { ReactComponent as Logo1 } from '../../assets/logo-day-mobile.svg';
import Constants from "../../services/constants";

export default function InvoicePopup({ open, onClose, invoice }) {
  const invoiceRef = useRef();

  if (!open) return null;

  const handlePrint = () => {
    const content = invoiceRef.current;

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";

    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    // Copy all stylesheets (VERY IMPORTANT for Tailwind)
    const styles = Array.from(document.styleSheets)
      .map(styleSheet => {
        try {
          return Array.from(styleSheet.cssRules)
            .map(rule => rule.cssText)
            .join("");
        } catch (e) {
          return "";
        }
      })
      .join("\n");

    doc.open();
    doc.write(`
      <html>
        <head>
          <title>Invoice</title>

          <style>
            ${styles}

            @media print {
              @page {
                size: A4;
                margin: 14mm;
              }
            }
          </style>
        </head>

        <body>
          ${content.outerHTML}
        </body>
      </html>
    `);
    doc.close();

    iframe.contentWindow.focus();

    setTimeout(() => {
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }, 500);
  };

  const getAmount = (amount) => {
    if(!amount || amount === 0)
      return 0;

    return amount/100;
  }

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

      <div className="bg-white w-[850px] rounded shadow-xl" >

        <div className="p-6 lic-text" ref={invoiceRef} >
          {/* Header */}
          <div className="flex justify-between items-start mb-6">
            <div>
              <p className="font-bold text-lg">
                SyncMama
              </p>

              <p className="text-sm text-gray-600">
                GSTIN - {Constants.ORG_ADDRESS.gst}
              </p>

              <p className="text-sm text-gray-600">
                CIN - {Constants.ORG_ADDRESS.cin}
              </p>
            </div>

            <div className="text-right">
              <div className="">
                <Logo1 />
              </div>
            </div>
          </div>

          {/* Invoice Body */}
          <div className="border p-6">

            <p className="text-lg font-semibold mb-4">
              Invoice # {invoice.id}
            </p>

            <div className="grid grid-cols-2 gap-6 my-2">
              <div className="">
                <p className="text-sm text-gray-500">AMOUNT DUE</p>
                <p className="text-xl font-semibold">₹ {getAmount(invoice.total)}</p>
              </div>
              <div className="">
                <p className="text-gray-500 text-sm">BILLING TO</p>
                <p>{invoice.email}</p>

              </div>
            </div>
            {/* Billing Section */}
            <div className="grid grid-cols-2 gap-6 my-2">

              
                {/* <p className="text-gray-500 text-sm">BILLING ADDRESS</p>
                <p>{invoice.billingAddress}</p>

                <div className="mt-4">
                  <p className="text-gray-500 text-sm">SHIPPING ADDRESS</p>
                  <p>{invoice.shippingAddress}</p>
                </div>

                <div className="mt-2">
                  <p className="text-gray-500 text-sm">PLACE OF SUPPLY</p>
                  <p>{invoice.placeOfSupply}</p>
                </div> */}

                <div className="">
                  <p className="text-gray-500 text-sm">ISSUE DATE</p>
                  <p>{invoice.issueDate}</p>
                </div>

                <div className="">
                  <p className="text-gray-500 text-sm">EXPIRY DATE</p>
                  <p>{invoice.expiryDate}</p>
                </div>

            </div>

            {/* Items Table */}
            <table className="w-full border mb-6">

              <thead className="bg-gray-100 text-gray-800 text-sm">
                <tr>
                  <th className="p-2 border text-black  text-left">DESCRIPTION</th>
                  <th className="p-2 border text-black ">RATE</th>
                  <th className="p-2 border text-black">QTY</th>
                  <th className="p-2 border text-black">TOTAL</th>
                </tr>
              </thead>

              <tbody>
                {invoice.items.map((item, i) => (
                  <tr key={i}>
                    <td className="p-2 border">{item.name}</td>
                    <td className="p-2 border text-center">₹ {getAmount(item.price)}</td>
                    <td className="p-2 border text-center">{item.qty}</td>
                    <td className="p-2 border text-center">
                      ₹ {getAmount(item.price * item.qty)}
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>

            {/* Totals */}
            <div className="text-right space-y-2">

              <div className="flex justify-end gap-10">
                <span className="font-semibold">Total Amount</span>
                <span>₹ {getAmount(invoice.total)}</span>
              </div>

              <div className="flex justify-end gap-10 text-green-600">
                <span className="font-semibold">Amount Paid</span>
                <span>₹ {getAmount(invoice.paid)}</span>
              </div>

              <div className="flex justify-end gap-10">
                <span className="font-semibold">Amount Due</span>
                <span>₹ {getAmount(invoice.total - invoice.paid)}</span>
              </div>

            </div>

          </div>
        </div>
        {/* Actions */}
        <div className="flex justify-end gap-4 p-6">

          <button
            onClick={handlePrint}
            className="bg-pink-600 text-white px-4 py-2 rounded-full border-0"
          >
            Print
          </button>

          <button
            onClick={onClose}
            className="bg-black text-white px-4 py-2 rounded-full border-0"
          >
            Close
          </button>

        </div>
      </div>

    </div>
  );
}